var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index" },
    [
      _c("yqg-header"),
      _vm._v(" "),
      _c("banner"),
      _vm._v(" "),
      _c("about-us"),
      _vm._v(" "),
      _c("business"),
      _vm._v(" "),
      _c("yqg-video"),
      _vm._v(" "),
      _c("yqg-footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }